import React from 'react';
import { Code, Palette, Database, Wrench, BookOpen, Monitor } from 'lucide-react';
import './Skills.css';

const Skills = () => {
  const skillCategories = [
    {
      icon: <Code size={28} />,
      title: 'Langages de Programmation',
      skills: ['Java', 'Python', 'PHP', 'C', 'JavaScript', 'HTML/CSS'],
      color: '#d4af37',
    },
    {
      icon: <Database size={28} />,
      title: 'Bases de Données',
      skills: ['MySQL', 'PDO', 'MongoDB', 'Algèbre relationnelle '],
      color: '#f4d03f',
    },
    {
      icon: <Palette size={28} />,
      title: 'Technologies Frontend',
      skills: ['React', 'JavaScript', 'Tkinter', 'Swing', 'HTML/CSS'],
      color: '#d4af37',
    },
    {
      icon: <Wrench size={28} />,
      title: 'Outils & Systèmes',
      skills: ['Git', 'GitHub', 'Linux', 'Windows', 'Shell', 'Mac'],
      color: '#f4d03f',
    },
    {
      icon: <BookOpen size={28} />,
      title: 'Concepts & Méthodologies',
      skills: ['POO', 'MVC', 'Design Patterns', 'Algorithmes', 'Tests Unitaires'],
      color: '#d4af37',
    },
    {
      icon: <Monitor size={28} />,
      title: 'Mathématiques & Théorie',
      skills: ['Algorithmique', 'Algèbre', 'Mathématiques Discrètes'],
      color: '#f4d03f',
    },
  ];

  return (
    <section id="skills" className="skills">
      <div className="skills-container">
        
        {/* L'EN-TÊTE MODERNE QUE TU AS DEMANDÉ */}
        <div className="modern-section-header">
          <div className="modern-badge">
            <Wrench size={16} />
            <span>Expertises</span>
          </div>
          <h2 className="modern-title">
            Mes <span className="modern-highlight">Compétences</span>
          </h2>
          <p className="modern-subtitle">
            Les technologies et outils que je maîtrise pour créer des projets innovants
          </p>
        </div>

        {/* TON ANCIENNE GRILLE AVEC LES HEXAGONES */}
        <div className="skills-grid">
          {skillCategories.map((category, index) => (
            <div 
              key={index} 
              className="skill-hexagon"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className="hexagon-border" style={{ '--border-color': category.color }}>
                <div className="hexagon-content">
                  <div className="skill-icon" style={{ color: category.color }}>
                    {category.icon}
                  </div>
                  <h3 className="skill-title">{category.title}</h3>
                  <div className="skill-tags">
                    {category.skills.map((skill, idx) => (
                      <span key={idx} className="skill-tag">
                        {skill}
                      </span>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Skills;